import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { PipEmailSettings } from './PipEmailSettings';
import { PipRightsSettings } from './PipRightsSettings';
import { PipResolutionSettings } from './PipResolutionSettings';
import { EmailRecipientSetting } from '../Common/EmailRecipientSetting';
import { useDispatch, useSelector } from 'react-redux';
import {
	deletePerformancePlanStatus,
	getPerformancePlanEmailConf,
	getPerformancePlanSetting,
	getPerformancePlanStatus,
	insertPerformancePlanStatus,
	updatePerformancePlanSetting,
	updatePerformancePlanStatus,
	updatePerformancePlanStatusEnable,
	getEmailRecipient,
	updateEmailRecipient,
} from '../../../../../action/adminPerformanceDevelopment';
import { Enums, EnumEmailRecipients, EnumEmailModule } from '../../../../../config/enums';
import { useSnackbar } from 'notistack';
import { DialogComponent } from '../../../CommonComponent/DialogComponent';
import AlertDialog from '../../../../Common/Dialog';
import { getOkrMasterData } from '../../../../../action/myGoal';

export const AdminPerformanceImprovementPlan: React.FC<any> = (props: any) => {
	const { loader, setLoader } = props;
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { enqueueSnackbar } = useSnackbar();
	const { okrMasterData } = useSelector((state: any) => state?.okrReducer);

	const [performancePlanSettingDetails, setPerformancePlanSettingDetails] = useState<any>(null);
	const [performancePlanStatusDetails, setPerformancePlanStatusDetails] = useState<any>(null);
	const [performancePlanEmailConfDetails, setPerformancePlanEmailConfDetails] = useState<any>(null);
	const [isPerformancePlanStatusUpdated, setIsPerformancePlanStatusUpdated] = useState<boolean>(false);
	const [twoFactorModalProps, setTwoFactorModalProps] = useState<any>({ open: false, message: '', details: '' });
	const [modalProps, setModalProps] = useState<any>({ open: false, event: {}, message: '' });
	const [isPipTitlePrefilledTextError, setIsPipTitlePrefilledTextError] = useState<boolean>(false);
	const [modalFeedbackProps, setModalFeedbackProps] = useState<any>({
		open: false,
		details: null,
		type: '',
		message: '',
		isCancel: false,
	});

	useEffect(() => {
		dispatch(getOkrMasterData());
		renderDefaultAdminPIPData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const showMsg = (variant: any, messages: any) => {
		enqueueSnackbar(messages || `Error occurred while fetching comments`, {
			variant: variant || 'success',
			autoHideDuration: 3000,
		});
	};
	const emailSAubmitData = async () => {
		const response: any = await dispatch(getPerformancePlanEmailConf());
		if (response.status === 200) {
			const { entity } = response?.data || {};

			setPerformancePlanEmailConfDetails(entity || null);
		} else {
		}
	};
	const renderDefaultAdminPIPData = async () => {
		try {
			setLoader(true);
			Promise.allSettled([
				dispatch(getPerformancePlanSetting()),
				dispatch(getPerformancePlanStatus()),
				dispatch(getPerformancePlanEmailConf()),
			])
				.then((response: any) => {
					if (response) {
						const performancePlanSetting =
							Boolean(response) && response.length && response[0] && response[0].value ? response[0].value : null;
						const performancePlanStatus =
							Boolean(response) && response.length && response[1] && response[1].value ? response[1].value : null;
						const performancePlanEmailConf =
							Boolean(response) && response.length && response[2] && response[2].value ? response[2].value : null;

						if (Boolean(performancePlanSetting) && performancePlanSetting?.data?.status === Enums.STATUS_SUCCESS) {
							const { entity } = performancePlanSetting?.data || {};
							const settingDetails = entity
								? {
										...entity,
										allowReviewersToEditPIPHistory: entity?.allowReviewersToEditPIP || false,
										isPIPVisibleToRMHistory: entity?.isPIPVisibleToRM || false,
										isPIPTitlePrefilledHistory: entity?.isPIPTitlePrefilled || false,
										pipTitlePrefilledTextHistory: entity?.pipTitlePrefilledText || '',
										isPIPTitlePrefilledEditableHistory: entity?.isPIPTitlePrefilledEditable || false,
										isPastDateAllowedForPIPHistory: entity?.isPastDateAllowedForPIP || false,
										isPipAcknowledgementEnabled: entity?.isPipAcknowledgementEnabled || false,
								  }
								: null;
							setPerformancePlanSettingDetails(settingDetails);
						}
						if (Boolean(performancePlanStatus) && performancePlanStatus?.data?.status === Enums.STATUS_SUCCESS) {
							const { entityList } = performancePlanStatus?.data || {};
							let updatedPerformancePlanStatusDetails: any[] = entityList && entityList?.length ? [...entityList] : [];
							updatedPerformancePlanStatusDetails = updatedPerformancePlanStatusDetails
								.filter((item: any) => item?.isResolvedStatus)
								.map((item: any, index: any) => {
									const data = { ...item };
									data.historyName = data.name;
									return data;
								});
							setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails || []);
						}
						if (Boolean(performancePlanEmailConf) && performancePlanEmailConf?.data?.status === Enums.STATUS_SUCCESS) {
							const { entity } = performancePlanEmailConf?.data || {};

							setPerformancePlanEmailConfDetails(entity || null);
						}
						setLoader(false);
					}
				})
				.catch((error) => {
					console.error(error);
					setPerformancePlanSettingDetails(null);
					setPerformancePlanStatusDetails([]);
					setPerformancePlanEmailConfDetails(null);
					setLoader(false);
				});
		} catch (error) {
			console.error(error);
			setPerformancePlanSettingDetails(null);
			setPerformancePlanStatusDetails([]);
			setPerformancePlanEmailConfDetails(null);
			setLoader(false);
		}
	};
	const updatePerformancePlanSettingAPICall = async () => {
		try {
			const requestParams = performancePlanSettingDetails ? { ...performancePlanSettingDetails } : null;
			if (requestParams) {
				delete requestParams.allowReviewersToEditPIPHistory;
				delete requestParams.isPIPVisibleToRMHistory;
				delete requestParams.isPIPTitlePrefilledHistory;
				delete requestParams.pipTitlePrefilledTextHistory;
				delete requestParams.isPIPTitlePrefilledEditableHistory;
				delete requestParams.isPastDateAllowedForPIPHistory;
					(requestParams.pipTitlePrefilledText = requestParams.isPIPTitlePrefilled
						? requestParams.pipTitlePrefilledText
						: '');
				requestParams.isPIPTitlePrefilledEditable = requestParams.isPIPTitlePrefilled
					? requestParams.isPIPTitlePrefilledEditable
					: false;
				if (requestParams.isPIPTitlePrefilled && requestParams.pipTitlePrefilledText === '') {
					setIsPipTitlePrefilledTextError(true);
				} else {
					setLoader(true);
					setIsPipTitlePrefilledTextError(false);
					const response: any = await dispatch(updatePerformancePlanSetting(requestParams));
					if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
						const { messageList } = response?.data || {};
						const keys = messageList ? Object.keys(messageList) : [];
						const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
						showMsg('success', messages || `Performance improvement plan rights settings updated successfully.`);
						const settingDetails = requestParams
							? {
									...requestParams,
									allowReviewersToEditPIPHistory: requestParams?.allowReviewersToEditPIP || false,
									isPIPVisibleToRMHistory: requestParams?.isPIPVisibleToRM || false,
									isPIPTitlePrefilledHistory: requestParams?.isPIPTitlePrefilled || false,
									pipTitlePrefilledTextHistory: requestParams?.pipTitlePrefilledText || '',
									isPIPTitlePrefilledEditableHistory: requestParams?.isPIPTitlePrefilledEditable || false,
									isPastDateAllowedForPIPHistory: requestParams?.isPastDateAllowedForPIP || false,
									isPipAcknowledgementEnabled: requestParams?.isPipAcknowledgementEnabled || false,
							  }
							: null;
						setPerformancePlanSettingDetails(settingDetails);
						setIsPerformancePlanStatusUpdated(false);
						setLoader(false);
					} else {
						const { messageList } = response?.data || {};
						const keys = messageList ? Object.keys(messageList) : [];
						const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
						showMsg('error', messages || `Some error occurred`);
						setLoader(false);
					}
				}
			}
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};
	const resetPerformanceDevelopmentSetting = () => {
		try {
			const settingDetails = performancePlanSettingDetails
				? {
						...performancePlanSettingDetails,
						allowReviewersToEditPIP: performancePlanSettingDetails?.allowReviewersToEditPIPHistory || false,
						isPIPVisibleToRM: performancePlanSettingDetails?.isPIPVisibleToRMHistory || false,
						isPIPTitlePrefilled: performancePlanSettingDetails?.isPIPTitlePrefilledHistory || false,
						pipTitlePrefilledText: performancePlanSettingDetails?.pipTitlePrefilledTextHistory || '',
						isPIPTitlePrefilledEditable: performancePlanSettingDetails?.isPIPTitlePrefilledEditableHistory || false,
						isPastDateAllowedForPIP: performancePlanSettingDetails?.isPastDateAllowedForPIP || false,
						isPipAcknowledgementEnabled: performancePlanSettingDetails?.isPipAcknowledgementEnabled || false,
				  }
				: null;
			setPerformancePlanSettingDetails(settingDetails);
			setIsPerformancePlanStatusUpdated(false);
		} catch (error) {
			console.error(error);
		}
	};
	// ================================================
	// ================================================
	const handleStatusNameChangeClick = (e: any, statusItem: any, statusItemIndex: any) => {
		const { value } = e?.target || {};
		const updatedPerformancePlanStatusDetails: any[] =
			performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
		updatedPerformancePlanStatusDetails[statusItemIndex].name = value;
		setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails);
	};
	const createNewResolution = (e: any) => {
		// setIsCreateResolution(true);
		const updatedPerformancePlanStatusDetails: any[] =
			performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
		const newStatusInsert = {
			performanceImprovementPlanStatusId: Enums.ZERO,
			name: '',
			historyName: '',
			isDefault: false,
			isEnabled: true,
			isEditResolution: false,
			isCreateResolution: true,
		};
		updatedPerformancePlanStatusDetails.unshift(newStatusInsert);
		setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails);
	};
	const insertEditResolution = async (e: any, statusItem: any, statusItemIndex: any) => {
		try {
			if (statusItem?.name && statusItem.name.trim() !== '') {
				setLoader(true);
				const requestParams = {
					performanceImprovementPlanStatusId: statusItem?.performanceImprovementPlanStatusId || Enums.ZERO,
					name: statusItem?.name || '',
					description: statusItem?.name || '',
				};
				const response: any = await dispatch(insertPerformancePlanStatus(requestParams));
				if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('success', messages || `Resolution settings status created successfully.`);

					renderDefaultAdminPIPData();
					// setLoader(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('error', messages || `Some error occurred`);
					setLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const cancelCreateResolution = (e: any, statusItem: any, statusItemIndex: number) => {
		e.preventDefault();
		// setIsCreateResolution(false);
		let updatedPerformancePlanStatusDetails: any[] =
			performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
		updatedPerformancePlanStatusDetails = updatedPerformancePlanStatusDetails.filter(
			(item: any, index: number) => index !== statusItemIndex
		);
		// updatedPerformancePlanStatusDetails[statusItemIndex].isCreateResolution = false;
		setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails);
	};
	const editResolution = (e: any, statusItem: any, statusItemIndex: any) => {
		const updatedPerformancePlanStatusDetails: any[] =
			performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
		updatedPerformancePlanStatusDetails[statusItemIndex].isEditResolution = true;
		setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails);
	};
	const handleStatusChange = async (e: any, statusItem: any, statusItemIndex: any, fullList: any) => {
		try {
			if (statusItem?.performanceImprovementPlanStatusId) {
				const { checked } = e?.target || {};
				let isAPICall: boolean = false;
				if (!checked) {
					const updatedFullList = [...fullList].map((rec: any) => {
						const data = { ...rec };
						return data;
					});
					updatedFullList[statusItemIndex].isEnabled = false;
					const activeStatusList = updatedFullList?.filter((rec: any) => rec?.isEnabled);
					if (!activeStatusList?.length) {
						setModalFeedbackProps({
							open: true,
							type: 'resolutionSettings',
							message: 'At least 1 Resolve status needs to be active.',
							isCancel: true,
						});
					} else {
						isAPICall = true;
					}
				} else {
					isAPICall = true;
				}
				if (isAPICall) {
					setLoader(true);
					const requestParams = {
						performanceImprovementPlanStatusId: statusItem?.performanceImprovementPlanStatusId || Enums.ZERO,
						isEnabled: checked || false,
					};
					const response: any = await dispatch(updatePerformancePlanStatusEnable(requestParams));
					if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
						const { messageList } = response?.data || {};
						const keys = messageList ? Object.keys(messageList) : [];
						const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
						showMsg('success', messages || `Resolution settings status updated successfully.`);

						renderDefaultAdminPIPData();
						// setLoader(false);
					} else {
						const { messageList } = response?.data || {};
						const keys = messageList ? Object.keys(messageList) : [];
						const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
						showMsg('error', messages || `Some error occurred`);
						setLoader(false);
					}
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const updateEditResolution = async (e: any, statusItem: any, statusItemIndex: any) => {
		try {
			if (statusItem?.performanceImprovementPlanStatusId) {
				setLoader(true);
				const requestParams = {
					performanceImprovementPlanStatusId: statusItem?.performanceImprovementPlanStatusId || Enums.ZERO,
					name: statusItem?.name || '',
					description: statusItem?.name || '',
				};
				const response: any = await dispatch(updatePerformancePlanStatus(requestParams));
				if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('success', messages || `Resolution settings status updated successfully.`);

					renderDefaultAdminPIPData();
					// setLoader(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('error', messages || `Some error occurred`);
					setLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
		}
	};
	const cancelEditResolution = (e: any, statusItem: any, statusItemIndex: any) => {
		e.preventDefault();
		const updatedPerformancePlanStatusDetails: any[] =
			performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
		updatedPerformancePlanStatusDetails[statusItemIndex].name =
			updatedPerformancePlanStatusDetails[statusItemIndex].historyName;
		updatedPerformancePlanStatusDetails[statusItemIndex].isEditResolution = false;
		// updatedPerformancePlanStatusDetails.map((item: any, index: any) => {
		// 	const data = { ...item };
		// 	data.isEditResolution = false;
		// 	return data;
		// });
		setPerformancePlanStatusDetails(updatedPerformancePlanStatusDetails);
	};
	const deletePerformancePlanStatusApiCall = async (statusItem: any, statusItemIndex: number) => {
		try {
			if (statusItem?.performanceImprovementPlanStatusId) {
				setLoader(true);
				const requestParams = `performanceImprovementPlanStatusId=${statusItem?.performanceImprovementPlanStatusId}`;
				const response: any = await dispatch(deletePerformancePlanStatus(requestParams));
				if (response && response?.data?.status === Enums.STATUS_SUCCESS) {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('success', messages || `Resolution settings status deleted successfully.`);

					renderDefaultAdminPIPData();
					// setLoader(false);
				} else {
					const { messageList } = response?.data || {};
					const keys = messageList ? Object.keys(messageList) : [];
					const messages = keys && keys.length ? keys.map((item) => messageList[item]) : '';
					showMsg('error', messages || `Some error occurred`);
					setLoader(false);
				}
			}
		} catch (error) {
			console.error(error);
			setLoader(false);
		}
	};
	const handleDeleteResolution = (e: any, statusItem: any, statusItemIndex: any) => {
		if (statusItem?.performanceImprovementPlanStatusId) {
			// setModalProps({
			// 	open: true,
			// 	event: null,
			// 	details: { statusItem, statusItemIndex },
			// 	type: 'DeleteResolution',
			// 	message: t('Are you sure you want to delete this performance improvement plan resolution status?'),
			// });
			setTwoFactorModalProps({
				open: true,
				message: {
					headingText: '',
					subHeading: t('pipFeedbackDeletionText'),
				},
				details: { statusItem, statusItemIndex },
			});
		} else {
			let updatedPerformancePlanStatusDetails =
				performancePlanStatusDetails && performancePlanStatusDetails?.length ? [...performancePlanStatusDetails] : [];
			updatedPerformancePlanStatusDetails?.filter((item: any, index: number) => index !== statusItemIndex);
			setPerformancePlanStatusDetails([...updatedPerformancePlanStatusDetails]);
		}
	};
	const handleTwoFactorCloseModal = async (e: any, type: any) => {
		if (type === 1) {
			const { statusItem, statusItemIndex } = twoFactorModalProps?.details || {};
			setTwoFactorModalProps({ open: false, message: '', details: '' });
			deletePerformancePlanStatusApiCall(statusItem, statusItemIndex);
		} else {
			setTwoFactorModalProps({ open: false, message: '', details: '' });
		}
	};
	const handleCloseModal = (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
			if (modalProps?.type === 'DeleteResolution') {
				const { statusItem, statusItemIndex } = modalProps?.details || {};
				deletePerformancePlanStatusApiCall(statusItem, statusItemIndex);
			}
		}
		setModalProps({ open: false, event: null, message: '' });
	};
	// ================================================
	// ================================================
	const handleCloseFeedbackModal = async (e: any, type: any) => {
		e.preventDefault();
		if (type === 1) {
		} else if (type === 2) {
			if (modalFeedbackProps?.type === 'resolutionSettings') {
				// renderDefaultAdminPIPData();
				setModalFeedbackProps({ open: false, type: '', message: '', details: null, isCancel: false });
			}
		}
	};

	return (
		<>
			<Box className='performance-development-settings'>
				<EmailRecipientSetting
					t={t}
					loader={loader}
					messageNote={t('sendUpdateEmailsToNotePIP')}
					emailModuleId={EnumEmailModule.PIP}
					setLoader={setLoader}
				/>

				{performancePlanEmailConfDetails ? (
					<PipEmailSettings
						t={t}
						loader={loader}
						setLoader={setLoader}
						performancePlanEmailConfDetails={performancePlanEmailConfDetails}
						showMsg={showMsg}
						emailSAubmitData={emailSAubmitData}
					/>
				) : (
					<></>
				)}
				{performancePlanStatusDetails ? (
					<PipResolutionSettings
						t={t}
						loader={loader}
						performancePlanStatusDetails={performancePlanStatusDetails}
						// isCreateResolution={isCreateResolution}
						createNewResolution={createNewResolution}
						insertEditResolution={insertEditResolution}
						cancelCreateResolution={cancelCreateResolution}
						// isEditResolution={isEditResolution}
						updateEditResolution={updateEditResolution}
						editResolution={editResolution}
						cancelEditResolution={cancelEditResolution}
						handleDeleteResolution={handleDeleteResolution}
						handleStatusNameChangeClick={handleStatusNameChangeClick}
						handleStatusChange={handleStatusChange}
					/>
				) : (
					<></>
				)}
				{performancePlanSettingDetails ? (
					<PipRightsSettings
						t={t}
						loader={loader}
						isPipTitlePrefilledTextError={isPipTitlePrefilledTextError}
						setIsPipTitlePrefilledTextError={setIsPipTitlePrefilledTextError}
						setPerformancePlanSettingDetails={setPerformancePlanSettingDetails}
						performancePlanSettingDetails={performancePlanSettingDetails}
						updatePerformancePlanSettingAPICall={updatePerformancePlanSettingAPICall}
						resetPerformanceDevelopmentSetting={resetPerformanceDevelopmentSetting}
						isPerformancePlanStatusUpdated={isPerformancePlanStatusUpdated}
						setIsPerformancePlanStatusUpdated={setIsPerformancePlanStatusUpdated}
					/>
				) : (
					<></>
				)}
			</Box>
			{twoFactorModalProps && twoFactorModalProps.open && (
				<DialogComponent
					module='confirmation'
					modalOpen={twoFactorModalProps.open}
					handleCloseModal={(e: any) => handleTwoFactorCloseModal(e, 2)}
					matchString={Enums.DELETE_TEXT}
					handleConfirmClick={(e: any) => handleTwoFactorCloseModal(e, 1)}
					headingText={twoFactorModalProps?.message?.headingText}
					subHeading={twoFactorModalProps?.message?.subHeading}
				/>
			)}
			{modalProps?.open && (
				<AlertDialog
					message={modalProps?.message || ''}
					handleCloseModal={handleCloseModal}
					modalOpen={modalProps.open}
				/>
			)}
			{modalFeedbackProps?.open && (
				<AlertDialog
					message={modalFeedbackProps?.message || ''}
					handleCloseModal={handleCloseFeedbackModal}
					modalOpen={modalFeedbackProps.open}
					isCancel={modalFeedbackProps.isCancel}
				/>
			)}
		</>
	);
};
